import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Layout from "../components/Layout";
import PageHeading from "../components/PageHeading";
import Card from "../components/Card";
import CardLoader from "../components/CardLoader";
import { useLikedList } from "../hooks/useFavoriteLists";

const TABS = [
  { id: "clubs", label: "Clubs" },
  { id: "artists", label: "Artists" },
  { id: "events", label: "Events" },
];

const EMPTY_TEXT = {
  clubs: "No favourite clubs yet",
  artists: "No favourite artists yet",
  events: "No favourite events yet",
};

const Favourites = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const selectedTab = TABS.some((tab) => tab.id === tabParam)
    ? tabParam
    : "clubs";

  const clubs = useLikedList("clubs", selectedTab === "clubs");
  const artists = useLikedList("artists", selectedTab === "artists");
  const events = useLikedList("events", selectedTab === "events");

  const lists = { clubs, artists, events };
  const { items, isLoading } = lists[selectedTab];

  return (
    <Layout seo={{ title: "Favourites | Azzir Events", noindex: true }}>
      <PageHeading title="Favourites" />
      <section className="hero fillter-sec section-gap favourites-page">
        <div className="container">
          <div className="favourites-tabs">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                type="button"
                className={`btn${selectedTab === tab.id ? " is-active" : ""}`}
                aria-pressed={selectedTab === tab.id}
                style={{
                  backgroundColor: selectedTab === tab.id ? "#000" : "#fff",
                  color: selectedTab === tab.id ? "#fff" : "#000",
                }}
                onClick={() => setSearchParams({ tab: tab.id })}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <div className="club-result-row section-gap-btm">
            <div className="card-list">
              <div className="row">
                {isLoading ? (
                  <>
                    <CardLoader />
                    <CardLoader />
                    <CardLoader />
                  </>
                ) : items.length ? (
                  items.map((item, index) => (
                    <Card
                      key={item?._id || index.toString()}
                      club={selectedTab === "clubs" ? item : undefined}
                      artist={selectedTab === "artists" ? item : undefined}
                      event={selectedTab === "events" ? item : undefined}
                      index={index}
                    />
                  ))
                ) : (
                  <div className="col-12">
                    <p className="no-data-found">{EMPTY_TEXT[selectedTab]}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Link to="#" className="back-to-top">
        <i className="fa fa-chevron-up"></i>
      </Link>
    </Layout>
  );
};

export default Favourites;
